var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import axios from 'axios';
import store from "../store";
var BASE_URL = process.env.VUE_APP_BASE_URL;
axios.defaults.withCredentials = true;
var api = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'chainId': (_a = store.getters.getSelectedChain) === null || _a === void 0 ? void 0 : _a.chainId.toString()
    },
});
// Add a request interceptor to dynamically set the Authorization header before each request is made
api.interceptors.request.use(function (config) {
    var _a, _b;
    var token = store.getters.getToken;
    if (token) {
        config.headers.Authorization = "Bearer ".concat(token);
    }
    var chainId = (_b = (_a = store.getters.getSelectedChain) === null || _a === void 0 ? void 0 : _a.chainId) === null || _b === void 0 ? void 0 : _b.toString();
    if (chainId) {
        config.headers['chainId'] = chainId;
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});
// Add a response interceptor to handle token expiration and refresh token
api.interceptors.response.use(function (response) {
    return response;
}, function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var originalRequest, refreshToken, response, newToken, refreshError_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                originalRequest = error.config;
                if (!((error.response.status === 403 || error.response.status === 401) && !originalRequest._retry)) return [3 /*break*/, 6];
                originalRequest._retry = true;
                refreshToken = store.getters.getRefreshToken;
                if (!refreshToken) return [3 /*break*/, 5];
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                store.commit('setToken', refreshToken);
                return [4 /*yield*/, api.get('/api/v1/auth/refresh')];
            case 2:
                response = _a.sent();
                newToken = response.data.access_token;
                store.commit('setToken', newToken);
                return [2 /*return*/, api(originalRequest)];
            case 3:
                refreshError_1 = _a.sent();
                console.error('Failed to refresh token:', refreshError_1);
                store.commit('logout', null);
                store.commit('goTo', '/');
                return [3 /*break*/, 4];
            case 4: return [3 /*break*/, 6];
            case 5:
                store.commit('logout', null);
                store.commit('goTo', '/');
                _a.label = 6;
            case 6: return [2 /*return*/, Promise.reject(error)];
        }
    });
}); });
//@ts-ignore
export var registerUser = function (body, params) { return __awaiter(void 0, void 0, void 0, function () {
    var error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.post('/api/v1/auth/register', body, { params: params })];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_1 = _a.sent();
                console.error(error_1);
                return [2 /*return*/, error_1];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var setNewPassword = function (body, params) { return __awaiter(void 0, void 0, void 0, function () {
    var error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.post('/api/v1/auth/set-new-password', body, { params: params })];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_2 = _a.sent();
                console.error(error_2);
                return [2 /*return*/, error_2];
            case 3: return [2 /*return*/];
        }
    });
}); };
//@ts-ignore
export var authenticateUser = function (body, params) { return __awaiter(void 0, void 0, void 0, function () {
    var error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.post('/api/v1/auth/authenticate', body, { params: params })];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_3 = _a.sent();
                console.error(error_3);
                return [2 /*return*/, error_3];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var changePasword = function (body, params) { return __awaiter(void 0, void 0, void 0, function () {
    var error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.post('/api/v1/auth/set-new-password', body, { params: params })];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_4 = _a.sent();
                console.error(error_4);
                return [2 /*return*/, error_4];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var deleteUser = function () { return __awaiter(void 0, void 0, void 0, function () {
    var error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.delete('/api/v1/users')];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_5 = _a.sent();
                console.error(error_5);
                return [2 /*return*/, error_5];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getUserProfile = function (body, params) { return __awaiter(void 0, void 0, void 0, function () {
    var error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.get('/api/v1/users/loadUser', body)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_6 = _a.sent();
                console.error(error_6);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getUserWallets = function (body, id, params) { return __awaiter(void 0, void 0, void 0, function () {
    var error_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.get('/api/v1/users/' + id + '/walletsWithNft ', body)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_7 = _a.sent();
                console.error(error_7);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var adminBotCycles = function (body, nr, cycles, params) { return __awaiter(void 0, void 0, void 0, function () {
    var error_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.get('/api/v1/admin/auto/' + nr + '/' + cycles, body)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_8 = _a.sent();
                console.error(error_8);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var adminPull = function (body, params) { return __awaiter(void 0, void 0, void 0, function () {
    var error_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.get('/api/v1/admin/auto/pull', body)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_9 = _a.sent();
                console.error(error_9);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getAvailableChains = function () { return __awaiter(void 0, void 0, void 0, function () {
    var error_10;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.get('/api/v1/ui/getAvailableChains')];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_10 = _a.sent();
                console.error(error_10);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getSuggestedUsername = function (body, params) { return __awaiter(void 0, void 0, void 0, function () {
    var error_11;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.get('/api/v1/auth/suggest-username', body)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_11 = _a.sent();
                console.error(error_11);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getActiveDailyTournament = function (body, params) { return __awaiter(void 0, void 0, void 0, function () {
    var error_12;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.get('/api/v1/tournaments/getActiveDailyTournament', body)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_12 = _a.sent();
                console.error(error_12);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getUserRewards = function (body, params) { return __awaiter(void 0, void 0, void 0, function () {
    var error_13;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.get('/api/v1/users/checkForRewards', body)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_13 = _a.sent();
                console.error(error_13);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getCoinPackages = function (body, params) { return __awaiter(void 0, void 0, void 0, function () {
    var error_14;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.get('/api/v1/game/powerUp/coin-packages', body)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_14 = _a.sent();
                console.error(error_14);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var attachWallet = function (body, params) { return __awaiter(void 0, void 0, void 0, function () {
    var error_15;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.post('/api/v1/users/' + store.getters.getUser.id + '/addWallet?id=' + store.getters.getUser.id + '&walletAddress=' + params.address, body)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_15 = _a.sent();
                console.error(error_15);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var mintTicket = function (body, params) { return __awaiter(void 0, void 0, void 0, function () {
    var error_16;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.post('/api/v1/test/mintMinersRushTicket?walletAddress=' + params.address, body)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_16 = _a.sent();
                console.error(error_16);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getCurrentTournament = function (body, params) { return __awaiter(void 0, void 0, void 0, function () {
    var error_17;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.get('/api/v1/ui/currentActive', body)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_17 = _a.sent();
                console.error(error_17);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getNextTournament = function (body, params) { return __awaiter(void 0, void 0, void 0, function () {
    var error_18;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.get('/api/v1/ui/nextStart', body)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_18 = _a.sent();
                console.error(error_18);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getMessage = function (wallet) { return __awaiter(void 0, void 0, void 0, function () {
    var error_19;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.get('/api/v1/auth/request-message/' + wallet, null)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_19 = _a.sent();
                console.error(error_19);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var resetPassword = function (body, params) { return __awaiter(void 0, void 0, void 0, function () {
    var error_20;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.post('/api/v1/auth/reset-password-message', body)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_20 = _a.sent();
                console.error(error_20);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getTournament = function (id, page) { return __awaiter(void 0, void 0, void 0, function () {
    var error_21;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.get('/api/v1/ui/tournament/' + id + '?page=' + page)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_21 = _a.sent();
                console.error(error_21);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getTournamentScores = function (id, page) { return __awaiter(void 0, void 0, void 0, function () {
    var error_22;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.get('/api/v1/ui/tournament/score/' + id + '?size=10&page=' + page)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_22 = _a.sent();
                console.error(error_22);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var contactMessage = function (body, params) { return __awaiter(void 0, void 0, void 0, function () {
    var error_23;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.post('/api/v1/ui/contact', body)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_23 = _a.sent();
                console.error(error_23);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
